import CancelIcon from '@mui/icons-material/Cancel';
import {
  Box,
  Button,
  Grid,
  IconButton,
  Popper,
  Typography,
} from '@mui/material';

interface dialogProps {
  open: boolean;
  title: string;
  anchorEl: any;
  arrowRef: any;
  secondBtnText?: string;
  firstBtnText?: string;
  onClose: () => void;
  onInaccurateClick?: () => void;
  onReviewClick?: () => void;
  setArrowRef: any;
}

export default function OrderDetailsPopover(props: dialogProps) {
  const {
    open,
    title,
    anchorEl,
    arrowRef,
    secondBtnText,
    firstBtnText,
    onClose,
    onInaccurateClick,
    onReviewClick,
    setArrowRef,
  } = props;

  return (
    <Popper
      open={open}
      sx={{ zIndex: 100 }}
      anchorEl={anchorEl}
      placement='top'
      modifiers={[
        {
          name: 'flip',
          enabled: false,
          options: {
            altBoundary: true,
            rootBoundary: 'document',
            padding: 8,
          },
        },
        {
          name: 'arrow',
          enabled: true,
          options: {
            element: arrowRef,
          },
        },
      ]}>
      <Box
        sx={{
          p: 1,
          bgcolor: 'background.paper',
          padding: 2.5,
          borderRadius: 1,
        }}>
        <Grid container paddingBottom={2}>
          <Grid
            item
            sx={{
              alignItems: 'center',
              justifyContent: 'center',
              display: 'flex',
              marginRight: 5,
              maxWidth: 500,
            }}>
            <Typography>{title}</Typography>
          </Grid>
          <Grid item>
            <IconButton
              onClick={onClose}
              color='primary'
              size='medium'
              sx={{ marginTop: -8, marginRight: -5.5 }}>
              <CancelIcon fontSize='large' className='cancel-btn' />
            </IconButton>
          </Grid>
        </Grid>
        <Grid container sx={{ justifyContent: 'space-between' }}>
          {onReviewClick && firstBtnText !== '' && (
            <Grid item>
              <Button
                variant='contained'
                color='success'
                onClick={onReviewClick}>
                {firstBtnText}
              </Button>
            </Grid>
          )}
          {secondBtnText != '' && (
            <Grid item>
              <Button
                color='warning'
                variant='contained'
                onClick={onInaccurateClick}>
                {secondBtnText}
              </Button>
            </Grid>
          )}
        </Grid>
      </Box>
      <div className='arrow' ref={setArrowRef} />
    </Popper>
  );
}
